export const TruncatedCell = ({
  value,
  maxLines = 2,
}: {
  value: string
  maxLines?: number
}) => {
  return (
    <div
      className="overflow-hidden text-ellipsis w-full text-sm"
      style={{
        maxHeight: `${maxLines * 1.2}rem`,
        display: "-webkit-box",
        WebkitLineClamp: maxLines,
        WebkitBoxOrient: "vertical",
        lineHeight: "1.2",
      }}
    >
      {value}
    </div>
  )
}
